import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CloneProjectDto, GeoProjectData, ProjectDto, ProjectsDto, ProjectToAdd } from '../models/Project';
import { ProjectSessionRequest, SquirrelSessionRequest, SquirrelSessionResponse } from '../models/SquirrelSession';
import { ProjectUserDto, ProjectUsersDto } from '../models/ProjectUser';
import { UserGroupRoleDto, UserGroupRolesDto } from '../models/GroupRole';
import { GenericFilter } from '../models/GenericFilter';
import { GeoDataDto } from '../models/ProjectMapInfo';
import { OAuthServiceService } from './o-auth-service.service';

@Injectable({ providedIn: 'root' })
export class ProjectService extends BaseService {
 
  constructor(private httpClient: HttpClient, private oauthService: OAuthServiceService) {
    super();
  }

  getProject(projectId: string): Observable<ProjectDto> {
    return this.httpClient.get<ProjectDto>(`${this.projects}/${projectId}`);
  }

  getProjectSessionData(projectname: string): Observable<ProjectSessionRequest> {
    return this.httpClient.get<ProjectSessionRequest>(`${this.projects}/ProjectWithSession?projectname=${projectname}`);
  }
  
  loadLegacyData(): Observable<any> {
    return this.httpClient.get<any>(`${this.localLegacySquirrelCommonApi}/TestConnection`);
  }

  loadProjects(searchText: string, page?: number, pageSize?: number): Observable<ProjectsDto> {
    return this.httpClient.get<ProjectsDto>(`${this.projects}?searchText=${searchText}&page=${page}&pageSize=${pageSize}`);
  }

  loadAllProjects(genericFilter: GenericFilter): Observable<ProjectDto[]> {
    return this.httpClient.post<ProjectDto[]>(`${this.projects}/GetFilteredProjects?genericFilter=genericFilter`, genericFilter);
  }

  loadProjectGeoData(genericFilter: GenericFilter): Observable<any> {
    return this.httpClient.post<any>(`${this.projects}/GetFilteredProjectGeoData?genericFilter=genericFilter`, genericFilter);
  }

  loadProjectGeoData1(genericFilter: GenericFilter): Observable<GeoProjectData> {
    return this.httpClient.post<GeoProjectData>(`${this.projects}/GetFilteredProjectGeoData?genericFilter=genericFilter`, genericFilter);
  }

  loadGeoData(genericFilter: GenericFilter): Observable<GeoDataDto> {
    return this.httpClient.post<GeoDataDto>(`${this.projects}/GeoData?genericFilter=genericFilter`, genericFilter);
  }

  getProjectUsers(searchText: string, projectId: string, page?: number, pageSize?: number): Observable<ProjectUsersDto> {
    return this.httpClient.get<ProjectUsersDto>(`${this.projects}/ProjectUsers?searchText=${searchText}&projectId=${projectId}&page=${page}&pageSize=${pageSize}`);
  }

  // loadProjectUsers(projectId: string, genericFilter: GenericFilter): Observable<ProjectUserDto[]> {
  //   return this.httpClient.post<ProjectUserDto[]>(`${this.projects}/${projectId}/GetFilteredProjectUsers`, genericFilter);
  // }

  getUserGroupRoles(searchText: string, userId: string, page?: number, pageSize?: number): Observable<UserGroupRolesDto> {
    return this.httpClient.get<UserGroupRolesDto>(`${this.projects}/${userId}/GroupRoles?searchText=${searchText}&page=${page}&pageSize=${pageSize}`);
  }

  loadUserGroupRoles(userId: any, projectId: any, genericFilter: GenericFilter): Observable<UserGroupRoleDto[]> {
    return this.httpClient.post<UserGroupRoleDto[]>(`${this.projects}/${userId}/GetFilteredUserGroupRoles/${projectId}`, genericFilter);
  }

  // addProject(projectToAdd: ProjectToAdd, tenantDb: string): Observable<ProjectToAdd> {
  //   const headers = new HttpHeaders()
  //     .set('Authorization', `Bearer ${this.oauthService.token}`)
  //     .set('dbname', tenantDb);
  //   return this.httpClient.post<ProjectToAdd>(`${this.projects}/AddNewProject`, projectToAdd, { headers: headers });
  // }

  // cloneProject(cloneProject: CloneProjectDto) : Observable<ProjectDto> {
  //   return this.httpClient.post<ProjectDto>(`${this.projects}/CloneProject`, cloneProject);
  // }

  createProjectSession(squirrelSessionRequest: SquirrelSessionRequest): Observable<SquirrelSessionResponse> {
    return this.httpClient.post<SquirrelSessionResponse>(`${this.projects}/CreateSession`, squirrelSessionRequest);
  }

  updateProject(project: ProjectDto): Observable<ProjectDto> {
    return this.httpClient.put<ProjectDto>(`${this.projects}/${project.id}`, project);
  }

  deleteProject(project: ProjectDto) {
    return this.httpClient.delete(`${this.projects}/${project.id}`);
  }
}
